import { useContext, useMemo } from "react";
import { GeaoContext } from "../../../GeaoContextProvider";

export default function useMappers(formData) {
    const { agencyInterview } = useContext(GeaoContext);

    const agencyAnswers = useMemo(() => {
        if (!formData) return null;

        return {
            Languages: { answer: formData.languageSelections?.join(",").toString() },
            LanguagesOther: { answer: formData.otherLanguageSelections?.trim() },
            ManagementSystemUsed: { answer: formData.managementSystem },
            ManagementSystemOther: { answer: formData.otherManagementSystem?.trim() },
            ComparativeRaterUsed: { answer: formData.comparativeRater },
            ComparativeRaterOther: { answer: formData.otherComparativeRater?.trim() },
            AcceptIvansDownload: { answer: formData.acceptsAndUsesIvansDownload?.toString() },
            IvansAccountId: { answer: formData.ivansAccountId?.toUpperCase().trim() },
            IvansUserId: { answer: formData.ivansUserId?.toUpperCase().trim() },
            Associations: { answer: formData.associations?.toString() }
        };
    }, [formData]);

    const defaultValues = useMemo(() => {
        const qa = agencyInterview?.questionAnswers || {};
        return {
            languageSelections: qa.Languages?.answer?.split(",")?.filter(Boolean) || [],
            otherLanguageSelections: qa.LanguagesOther?.answer || "",
            managementSystem: qa.ManagementSystemUsed?.answer || "",
            otherManagementSystem: qa.ManagementSystemOther?.answer || "",
            comparativeRater: qa.ComparativeRaterUsed?.answer || "",
            otherComparativeRater: qa.ComparativeRaterOther?.answer || "",
            acceptsAndUsesIvansDownload: qa.AcceptIvansDownload?.answer || "",
            ivansAccountId: qa.IvansAccountId?.answer || "",
            ivansUserId: qa.IvansUserId?.answer || "",
            associations: qa.Associations?.answer?.split(",")?.filter(Boolean) || [],
        };
    }, [agencyInterview]);

    return {
        agencyAnswers,
        defaultValues
    }
}